import type { Schemas } from "#shopware"

export const useMappedSizeLabels = (variants: Schemas["Product"][], manufacturerSizeSystem: string | null | undefined) => {
    const sizeLabelMap = new Map<string, { eu: string | null, uk: string | null }>()

    for (const variant of variants) {
        if (!variant.properties || !variant.options) continue
        const variantProps = variant.properties as Schemas["PropertyGroupOption"][]
        const euProp = variantProps.find(
            (p: Schemas["PropertyGroupOption"]) => p.group?.name === 'EU-Größe' || p.group?.translated?.name === 'EU-Größe'
        )
        if (!euProp) continue
        const originalSizeProp = variantProps.find(
            (p: Schemas["PropertyGroupOption"]) => p.group?.name === 'Größe' || p.group?.translated?.name === 'Größe'
        )
        const euLabel: string = euProp.translated?.name || euProp.name
        const originalSizeLabel: string | null = originalSizeProp?.translated?.name || originalSizeProp?.name || null
        for (const opt of variant.options as Schemas["PropertyGroupOption"][]) {
            sizeLabelMap.set(opt.id, { eu: euLabel, uk: originalSizeLabel })
        }
    }

    const hasUkSizes = manufacturerSizeSystem === 'uk' || manufacturerSizeSystem === 'us'
    const showUkSizes = ref(false)

    const toggleSizeMode = () => {
        showUkSizes.value = !showUkSizes.value
    }

    const getDisplayLabel = (option: Schemas["PropertyGroupOption"]): string => {
        const rawName = option.translated?.name || option.name
        const labels = sizeLabelMap.get(option.id)
        if (!labels) return rawName
        if (!showUkSizes.value) return labels.eu || rawName
        // UK mode: return uk label or "-" if no UK match exists
        return labels.uk || '-'
    }

    const getCombinedLabel = (option: Schemas["PropertyGroupOption"]): string => {
        const rawName = option.translated?.name || option.name
        const labels = sizeLabelMap.get(option.id)
        if (!labels) return rawName
        const ukLabel = labels.uk
        const euLabel = labels.eu || rawName
        if (!ukLabel) return '-'
        return `${ukLabel} (${euLabel})`
    }

    return {
        hasUkSizes,
        showUkSizes,
        toggleSizeMode,
        getDisplayLabel,
        getCombinedLabel,
    }
}